import React, { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { fetchAlerts } from "../../api/alerts";
import { fetchBanners } from "../../api/banners";
import { fetchCatalogs } from "../../api/catalogs";
import { fetchFiles } from "../../api/files";
import { fetchPromotions } from "../../api/promotions";
import { fetchSkirts } from "../../api/skirts";
import { findAlertDate, findAlertTitle } from "../../helpers";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../store/StoreContext";
import _ from "lodash";
import {
  MANUALS_CATEGORY,
  SKITRS_CATEGORY,
} from "../../constants/categories";

const brand = process.env.REACT_APP_BRAND || "S10";

const Portal = () => {
  const {
    setAlerts,
    setPromotions,
    setTopPromotions,
    setManuals,
    setSkirts,
    setPdfForPreview,
    setTopManuals,
    setTopCatalogs,
    setTopSkirts,
    setBanners,
  } = useContext(StoreContext);

  const handleFetchAlerts = async () => {
    const { data, error } = await fetchAlerts(brand);
    if (error) return;
    const _dataAlerts = data?.O_ALERTAS || [];
    const alerts = _.map(_dataAlerts, (alert, index) => {
      const date = findAlertDate(alert.ALERTA);
      const title = findAlertTitle(alert.ALERTA);
      return {
        id: index,
        start: _.get(date, 0, null),
        end: _.get(date, 1, null),
        title,
      };
    });
    setAlerts(alerts);
  };

  const handleFetchPromotions = async () => {
    const { data, error } = await fetchPromotions(brand, 333);
    if (error) return;
    setPromotions(data);
  };

  const handleFetchTopPromotions = async () => {
    const { data, error } = await fetchPromotions(brand, 333, 5);
    if (error) return;
    setTopPromotions(data);
  };

  const handleFetchManuals = async () => {
    const { data, error } = await fetchFiles(MANUALS_CATEGORY);
    if (error) return;
    const manuals = data?.data?.documents || [];
    setManuals(manuals);
  };

  const handleFetchSkirts = async () => {
    const { data, error } = await fetchSkirts();
    if (error) return;
    const skirts = data?.menu?.items || [];
    const _dataSkirts = skirts.map((skirt) => ({
      ...skirt,
      id: Number(skirt.id),
      parent: skirt?.parent ? Number(skirt.parent) : 0,
    }));
    setSkirts(_dataSkirts);
  };

  const handleFetchCatalogs = async () => {
    const { data, error } = await fetchCatalogs();
    if (error) return;
    const catalogs = data?.data?.details || [];
    setTopCatalogs(catalogs.slice(0, 5));
    if (catalogs?.length > 0) setPdfForPreview(catalogs[0]);
  };

  const handleFetchTopManuals = async () => {
    const { data, error } = await fetchFiles(MANUALS_CATEGORY, 5);
    if (error) return;
    const topManuals = data?.data?.documents || [];
    setTopManuals(topManuals);
  };

  const handleFetchTopSkirts = async () => {
    const { data, error } = await fetchFiles(SKITRS_CATEGORY, 5);
    if (error) return;
    const topSkirts = data?.data?.documents || [];
    setTopSkirts(topSkirts);
  };

  const handleFetchBanners = async () => {
    const { data, error } = await fetchBanners();
    if (error) return;
    const banners = data?.data?.documents || [];
    setBanners(banners);
  };

  useEffect(() => {
    handleFetchAlerts();
    handleFetchPromotions();
    handleFetchTopPromotions();
    handleFetchManuals();
    handleFetchSkirts();
    handleFetchCatalogs();
    handleFetchTopManuals();
    handleFetchTopSkirts();
    handleFetchBanners();
  }, []);

  return <Outlet />;
};

export default Portal;
